import {useSelector} from "react-redux";
import setPageTitle from "../services/TitleService";
import LeftSide from "../components/Blocks/Leftside/LeftSide";
import Content from "../components/Scoresheet/Content";
import React from "react";
import UnathorizedRedirect from "../services/UnathorizedRedirect";

export const Scoresheet = () => {
    const personinfo = useSelector(state => state.user.userInfo);
    UnathorizedRedirect(personinfo, 'Lecturer');
    setPageTitle('Score-sheet');
    return (
        <div className="d-flex position-relative">
            <LeftSide personinfo={personinfo}/>
            <Content personinfo={personinfo}/>
        </div>
    )
}
export default Scoresheet;